import { ChevronRight, ExternalLink, Search } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SETTINGS } from '@/config/settings';

export const SettingsHub: React.FC = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    if (!q) return SETTINGS;
    return SETTINGS.filter(
      (s) =>
        s.label.toLowerCase().includes(q) ||
        s.description.toLowerCase().includes(q),
    );
  }, [search]);

  return (
    <div className="mx-auto max-w-3xl px-6 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="text-muted-foreground mt-1 text-sm">
          Account configuration and integrations.
        </p>
      </div>

      <div className="relative mb-6 max-w-sm">
        <Search className="text-muted-foreground pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
        <input
          type="text"
          placeholder="Search settings..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring h-9 w-full rounded-md border py-2 pl-9 pr-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        />
      </div>

      {filtered.length === 0 ? (
        <p className="text-muted-foreground py-12 text-center text-sm">
          No settings match your search.
        </p>
      ) : (
        <div className="divide-y divide-zinc-200 rounded-lg border border-zinc-200 bg-white dark:divide-zinc-700 dark:border-zinc-700 dark:bg-zinc-800">
          {filtered.map((setting) => {
            const isExternal = !!setting.externalUrl;
            return (
              <button
                key={setting.label}
                type="button"
                className="flex w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-zinc-50 dark:hover:bg-zinc-700/50 first:rounded-t-lg last:rounded-b-lg"
                onClick={() => {
                  if (setting.externalUrl) {
                    window.location.href = setting.externalUrl();
                  } else if (setting.path) {
                    navigate(setting.path);
                  }
                }}
              >
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
                    {setting.label}
                  </div>
                  <div className="text-sm text-zinc-500 dark:text-zinc-400">
                    {setting.description}
                  </div>
                </div>
                {isExternal ? (
                  <ExternalLink className="size-4 shrink-0 text-zinc-500" />
                ) : (
                  <ChevronRight className="size-4 shrink-0 text-zinc-500" />
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
